import { render, staticRenderFns } from "./ParentGame.vue?vue&type=template&id=b271f2b4"
import script from "./ParentGame.vue?vue&type=script&lang=js"
export * from "./ParentGame.vue?vue&type=script&lang=js"
import style0 from "./ParentGame.vue?vue&type=style&index=0&id=b271f2b4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports